// extracted by mini-css-extract-plugin
export default {"container":"ServiceCard_container__OZZ9N","icon":"ServiceCard_icon__fCky2"};